import React from 'react'
// import Link from 'gatsby-link'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import presets from "../../../../../../utils/presets"

import SEOHelmet from '../../../../../../components/Layout/SEOHelmet'
import Footer from "../../../../../../components/Layout/footer"
import BreadCrumbs from '../../../../../../components/Layout/breadcrumbs/breadcrumbs'
import FloatingGallery from "../../../../../../components/Products/Software/instarvision-iPhone-wizard-floating-gallery"

const styles = {
  floatingbutton: {
    float: 'right',
    background: presets.brand,
    color: 'white!important',
  },
}

const seodata = {
  title: 'iPhone App InstarVision',
  description: 'The DDNS Access gives you full access to all your cameras functions. As well as allowing you to access its web user interface through your browser.',
  image: '/images/Search/P_SearchThumb_InstarVision_iOS.png'
}

function InstarVisionDDNS(props) {
  // const { classes, location } = props;
  const { location } = props;
  return (
    <React.Fragment>
      <SEOHelmet title={seodata.title} description={seodata.description} image={seodata.image} location={location.pathname} />
      <h1 css={{ marginTop: 0 }}>InstarVision Surveillance Center</h1>
      <h2>InstarVision iPhone App</h2>

      <BreadCrumbs
        pills={
          [
            {
              pill: "Software",
              link: "/fr/Software/"
            },
            {
              pill: "iOS",
              link: "/fr/Software/iOS/"
            },
            {
              pill: "InstarVision",
              link: "/fr/Software/iOS/InstarVision/"
            },
            {
              pill: "iPhone",
              link: "/fr/Software/iOS/InstarVision/iPhone/"
            },
          ]
        } />

      <h3>Installation Wizard</h3>
      <p>After you have installed the newest version please start the App and swipe to the right to enter the Cameras tab. The <strong>+</strong> symbol in the upper right lets you choose among three ways to add your IP camera.</p>
      <br />
      <br />
      <FloatingGallery />
      <br />
      <br />
      {/* <h3>Add an INSTAR DDNS IP Camera</h3>
      <table>
        <tbody>
          <tr>
            <th>DDNS or P2P</th>
            <td>First you have to choose to add your camera via its local IP / DDNS address or its P2P UID. For the Point-2-Point Service please <a href="/fr/Software/Android/InstarVision/P2P/">Continue Reading Here</a>.</td>
          </tr>
          <tr>
            <th>Camera Model</th>
            <td>InstarVision allows you to add cameras from different manufacturers beside INSTAR. Please choose the correct brand and model of your camera. You can also opt to simply scan your camera's QRcode from the DDNS menu: (<Link to="/Web_User_Interface/720p_Series/Network/DDNS/">720p</Link> / <Link to="/Web_User_Interface/1080p_Series/Network/Remote_Access/">1080p</Link>) - it will automatically fill out all the necessary information to add your camera!</td>
          </tr>
          <tr>
            <th>Camera Name</th>
            <td>You can choose a name for your camera - the name does not have to be identical with the camera name inside the web user interface.</td>
          </tr>
          <tr>
            <th>Host / IP Address</th>
            <td>Type your camera's local IP address (e.g. 192.168.178.26) to access your camera at home or use your DDNS address (e.g. abcd12.ddns-instar.de) when you want to be able to access your camera from the road. Please be aware that you will need a <Link to="/Internet_Access/Port_Forwarding/">Port Forwarding</Link> rule inside your internet router to use the <Link to="/Internet_Access/The_DDNS_Service/">DDNS Service</Link>!</td>
          </tr>
          <tr>
            <th>Port</th>
            <td>Type in the camera's http port, that can be found and set in the camera's web user interface: (<Link to="/Web_User_Interface/720p_Series/Network/IP_Configuration/">720p</Link> / <Link to="/Web_User_Interface/1080p_Series/Network/IP_Configuration/">1080p</Link>). The default value is 80 - but we recommend that you change it to the port 8081 or higher. Please be aware that you will need a <Link to="/Internet_Access/Port_Forwarding/">Port Forwarding</Link> rule inside your internet router to use the <Link to="/Internet_Access/The_DDNS_Service/">DDNS Service</Link>!</td>
          </tr>
          <tr>
            <th>User Name</th>
            <td>To access your camera you will need to provide the username you use to log in to your camera's web user interface. The default username for both HD and VGA cameras is <strong>admin</strong>.</td>
          </tr>
          <tr>
            <th>Password</th>
            <td>Provide the password you use to log in to your camera's web user interface. The default password is <strong>instar</strong> for HD cameras and no password for VGA cameras.</td>
          </tr>
          <tr>
            <th>Test/Add</th>
            <td>Afterwards click on Test to check your configuration. Click on Save once the test was successful. Go to the <Link to="/Software/Android/InstarVision/Multiview/">Multiview Menu</Link> to access your cameras live video stream.</td>
          </tr>
        </tbody>
      </table> */}
      <br />
      <br />
      <Footer
        previousTitle="InstarVision (iPhone)"
        previousLink="/fr/Software/iOS/InstarVision/iPhone/"
        nextTitle="P2P Menu"
        nextLink="/fr/Software/iOS/InstarVision/iPhone/P2P/" />
    </React.Fragment>
  );
}

InstarVisionDDNS.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(InstarVisionDDNS);